"use client";

/** Lien footer pour rouvrir la bannière de consentement cookies. */
export function CookieSettingsLink({ className }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event("fyt:open-cookie-settings"))}
      className={className}
    >
      Cookies
    </button>
  );
}
